module.exports = __webpack_public_path__ + "img/furry_ghost_hotel_en.357ba693.png";